import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook that automatically clears authentication tokens
 * when navigating to public pages from admin areas
 */
export const useNavigationGuard = () => {
  const location = useLocation();
  const { clearTokensForPublicPages, isAuthenticated } = useAuth();

  useEffect(() => {
    // Only run the guard if user is currently authenticated
    if (isAuthenticated) {
      const tokensCleared = clearTokensForPublicPages();
      
      if (tokensCleared) {
        // console.log('Navigation guard: Tokens cleared for public page access');
      }
    }
  }, [location.pathname, isAuthenticated, clearTokensForPublicPages]);

  return null;
};
